module.exports = __webpack_public_path__ + "static/img/12.b136973.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting790/images/12.png
// module id = dEUw
// module chunks = 4